module.exports = __webpack_public_path__ + "img/aParty_111223_C.44be2efb.jpg";